import { NgModule } from '@angular/core';
import { InputWithAutocompleteComponent } from './input-with-autocomplete.component';

@NgModule({
	declarations: [],
	imports: [InputWithAutocompleteComponent],
	exports: [InputWithAutocompleteComponent],
})
export class InputWithAutocompleteModule {}
